module.exports = __webpack_public_path__ + "static/media/direct.e40afda7.svg";